/**
 * Shared API helper for Teacher Portal sections.
 *
 * Uses the same preview-token fallback as the parent TeacherPortal.jsx so
 * "View as teacher" preview links work everywhere without re-implementing
 * the same fetch wrapper in each file.
 */
import { getToken } from '@/lib/authToken';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const _effective = () => {
  try {
    const pt = sessionStorage.getItem('school_preview_token');
    if (pt) return pt;
  } catch (_e) { /* sessionStorage unavailable */ }
  return getToken();
};

/** All teacher-portal sections POST/GET against /api/school/portal/teacher/* */
export const portalApi = async (path, opts = {}) => {
  const res = await fetch(`${API_URL}/api/school/portal${path}`, {
    ...opts,
    headers: {
      Authorization: `Bearer ${_effective()}`,
      'Content-Type': 'application/json',
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  return res.json();
};

/** General /api/school/* (e.g. tenants/{id}/lessons, assignments) */
export const schoolApi = async (path, opts = {}) => {
  const res = await fetch(`${API_URL}/api/school${path}`, {
    ...opts,
    headers: {
      Authorization: `Bearer ${_effective()}`,
      'Content-Type': 'application/json',
      ...(opts.headers || {}),
    },
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.detail || `Request failed (${res.status})`);
  }
  return res.json();
};
